'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("ButtonGroup", {
  root: (maxWidth) => react.css`
    ${styleMixins_reset.boxSizing};
    max-width: ${maxWidth};
  `,
  inner: (justify, columnSize) => react.css`
    ${styleMixins_reset.boxSizing};
    display: grid;
    gap: var(--zds-space-12, 10px) var(--zds-space-20, 20px);
    justify-content: ${justify};
    grid-template-columns: repeat(auto-fit, ${columnSize});
  `
});
const ButtonGroup = ({ children, columnSize = "minmax(0, 1fr)", justify = "start", maxWidth = "initial" }) => {
  return react.jsx(
    "div",
    { css: Styles.root(maxWidth), "data-zds": true },
    react.jsx("div", { css: Styles.inner(justify, columnSize), "data-zds": true }, children)
  );
};

exports.ButtonGroup = ButtonGroup;
//# sourceMappingURL=ButtonGroup.cjs.js.map
